'use strict';

var SVPCustomEvent = window.CustomEvent;

function _createCustomEvent() {

    SVPCustomEvent = function (event, params) {
        var evt;
        params = params || {
            bubbles: false,
            cancelable: false,
            detail: undefined
        };

        try {
            evt = document.createEvent("CustomEvent");
            evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        } catch(e) {
            // Older devices does not support CustomEvent
            evt = document.createEvent("Event");
            evt.initEvent(event, params.bubbles, params.cancelable);
            evt.detail = params.detail;
        }

        return evt;
    };

    SVPCustomEvent.prototype = window.Event.prototype;
}

if (!SVPCustomEvent || typeof SVPCustomEvent !== 'function') {
    _createCustomEvent();
} else {
    try {
        new SVPCustomEvent();
    } catch (e) {
        _createCustomEvent();
    }
}

module.exports = SVPCustomEvent;



// WEBPACK FOOTER //
// ./src/js/util/custom-event.js